import React from "react";

const SchedulesForm = ({ loading, onSubmit, initialValues, labelSaveButton }) => {
  // Componente básico para permitir compilação
  // TODO: Implementar funcionalidade completa
  return null;
};

export default SchedulesForm;

